







































import { Vue, Component, Prop } from 'vue-property-decorator'
import { uploadTaiwanStudentFile } from "@/apis/enroll/taiwanEnroll"
import { download } from "@/utils/download"
import { alert, notify } from '@/utils/notification'
import type { TaiwanEnroll } from '@/models/enrolls/taiwanEnroll'
import type { HttpRequestOptions } from 'element-ui/types/upload'

enum UploadState {
  ready,
  uploading,
  done,
  error
}

@Component
export default class Uploader extends Vue {
  @Prop({ required: true }) value!: TaiwanEnroll
  @Prop({ default: false }) print!: boolean
  @Prop({ default: '' }) title!: string

  uploadState = this.allowDownload ? UploadState.done: UploadState.ready

  explains = [
    "《上海师范大学2021年台湾地区高中毕业生入学申请表》（附件一）；",
    "《个人成绩查询授权委托书》（附件三），由本人签字或签章，原件、扫描版、影印版均可；",
    "有效的台湾居民居住证或台湾居民来往大陆通行证（简称台胞证）和台湾居民身份证复印件；",
    "当年的《台湾地区入学考试学科能力测验考生成绩通知单》复印件（含报名序号，须加盖学校公章）；",
    "中学成绩证明影印本（须加盖学校公章）。"
  ]

  get form() {
    return this.value
  }

  set form(value: TaiwanEnroll) {
    if (!this.print) {
      this.$emit('update:value', value)
    }
  }

  get allowDownload() {
    return !!this.form.reportCardUrl
  }

  get uploading() {
    return this.uploadState === UploadState.uploading
  }

  get uploadButtonType() {
    switch (this.uploadState) {
      case UploadState.done:
        return "success";

      case UploadState.error:
        return "danger";

      case UploadState.uploading:
      case UploadState.ready:
      default:
        return "primary";
    }
  }

  get uploadTip() {
    switch (this.uploadState) {
      case UploadState.done:
        return "重新上传";

      case UploadState.error:
        return "重试";

      case UploadState.uploading:
      case UploadState.ready:
      default:
        return "上传";
    }
  }

  beforeUpload(file:File) {
    const ext = file.name.substring(file.name.lastIndexOf('.') + 1)
    const allowExts = ['pdf']
    if (!allowExts.includes(ext)) {
      alert("文件格式错误", new Error("上传文件只能是PDF格式!"))
      return false
    }
    return true
  }

  async handleUpload(options: HttpRequestOptions) {
    const { file,onProgress } = options
    const onUploadProgress = (e: any) => {
      onProgress({
        ...e,
        percent: Math.round((e.loaded * 100) / e.total)
      })
    }

    try {
      this.uploadState = UploadState.uploading

      const baseURL= process.env.VUE_APP_BASE_API
      const url = await uploadTaiwanStudentFile(file,onUploadProgress)
      const filepath = url.replaceAll("\\","$").replaceAll("/","$");
      this.form.reportCardUrl =  `${baseURL}/student/TaiwanEnroll/files/${filepath}`

      alert("上传成功")
      this.uploadState = UploadState.done
      this.$emit("done")
    } catch(e) {
      alert("上传失败", e)
      this.uploadState = UploadState.error
    }
  }

  async handleDownload() {
    try {
      const TITLE = `台湾学测 ${this.form.name}.pdf`
      notify(`正在下载: ${TITLE}, 请耐心等待`)
      download(this.form.reportCardUrl, TITLE)
    } catch(e) {
      notify('下载失败', e)
    }
  }
}
